export default __webpack_public_path__ + "static/media/Chapati.cdbdc67b.jpg";